app.service("StyleRouteService", ['$rootScope', function ($rootScope) {

    const modelConstructor = $rootScope.model_constructor;

    const RouteChoice = modelConstructor.RouteChoice;

    const StyleRouteModel = modelConstructor.extend(modelConstructor.RouteModel, {
        id: "style_route",
        navigation_pointer: "style_id",
        name: "Style Route"
    });

    this.factory = new modelConstructor.RouteFactory({

        birth: function (values) {
            return new StyleRouteModel(values);
        },

        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;
        const browseID = variationIDs.browse_id;
        const baseComponentID = variationIDs.base_component_id;

        const styleModel = $rootScope.factory.style.getModel(variationIDs);
        const choiceOrder = styleModel.choice_order.slice();
        const fromChoices = styleModel.choices;
        const choices = {};
        for (let choiceID in fromChoices) {
            const fromChoice = fromChoices[choiceID];
            choices[choiceID] = new RouteChoice({
                id: choiceID,
                name: fromChoice.name,
                state_values: {
                    style_name: fromChoice.name,
                    style_prominent: variationIDs.site_range_id === "bella",
                    style_midrail: !!fromChoice.midrail,
                    style_surcharge: fromChoice.surcharge ? parseFloat(fromChoice.surcharge) : 0,
                    style_minimum_surcharge_height: fromChoice.minimum_surcharge_height ? parseFloat(fromChoice.minimum_surcharge_height) : 0,
                    style_img_src: fromChoice.getImgSrc(),
                    style_sloping_img_src: fromChoice.getImgSrc({image_type_id: 'sloping_style'})
                }
            })
        }

        let nextModelID;
        if (browseID === "solution" || baseComponentID === "solution") {
            nextModelID = "edge_option";
        } else if (browseID === "site_range") {
            nextModelID = "component";
        } else {
            if (baseComponentID === "stock") {
                nextModelID = "collection_product";
            } else {
                nextModelID = "individual_product";
            }
        }

        model.choice_order = choiceOrder;
        model.choices = choices;
        model.next_model_id = nextModelID;
    }

}]);